<div class="container-fluid">
    <div class="row">
        <div class="col-12" style="display:flex;justify-content: flex-start;">
            <button *ngIf="caseDetails && caseDetails.settings.allowEditAccountStatement && addAccountStatmentShow==false" class="btn btn-primary m-3"
                (click)="openCreateModal()">
                <i class="fa fa-plus-circle"></i>
                <span> {{'AddAccountStatment' | translate}} </span>
            </button>
        </div>
        <div class="col-sm-12" *ngIf="addAccountStatmentShow==false">
            <div class="card">
                <table class="table table-striped mt-3">
                    <thead class="thead-dark">
                        <tr>
                            <th>{{ "IdentityForInquery" | translate }}</th>
                            <th>{{ "Name" | translate }}</th>
                            <th>{{ "Nationality" | translate }}</th>
                            <th>{{ "FromDate" | translate }}</th>
                            <th>{{ "ToDate" | translate }}</th>
                            <th>{{ "createDate" | translate }}</th>
                            <th>{{ "prosecutionName" | translate }}</th>
                            <th>{{ "RequestStatus" | translate }}</th>
                            <th scope="col">{{"Preview" | translate}}</th>
                            <!-- <th scope="col" *ngIf="caseDetails && caseDetails.settings.allowEditAccountStatement">{{ "Edit" | translate }}</th>
                <th scope="col" *ngIf="caseDetails && caseDetails.settings.allowEditAccountStatement">{{ "Delete" | translate }}</th>-->
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let accountStatment of accountStatmentArr">
                            <td>{{ accountStatment.identityForInquery }}</td>
                            <td
                                *ngIf="accountStatment.firstName != '' && accountStatment.firstName != undefined && accountStatment.firstName !=null">
                                {{ accountStatment.firstName }} {{ accountStatment.secondName }} {{
                                accountStatment.thirdName }} {{ accountStatment.fourName }}</td>
                            <td
                                *ngIf="accountStatment.firstName == '' || accountStatment.firstName == undefined || accountStatment.firstName ==null">
                                -</td>
                            <td>{{accountStatment.nationalityName ? accountStatment.nationalityName : '-' }}</td>
                            <td>{{ accountStatment.startDate | toDateOnly }}</td>
                            <td>{{ accountStatment.endDate | toDateOnly }}</td>
                            <td>{{ accountStatment.createdOn | toDateOnly }}
                                <br />
                                <span *ngIf="accountStatment.creatorName!=null"
                                    style="font-size: 10px; ">{{'companyandBy'|translate}}:{{
                                    accountStatment.creatorName}}</span>
                            </td>
                            <td>{{ accountStatment.prosecutionName }}</td>
                            <td *ngIf="accountStatment.isAccepted==null">{{ "AwaitingApproval" | translate}}</td>
                            <td *ngIf="accountStatment.isAccepted==false">
                                <p style="margin: 0;">{{ "RequestHasBeenRejected" | translate}}</p>
                                <p style="margin: 0;">{{'TheReason' | translate}} : {{accountStatment.rejectReason}}</p>
                            </td>
                            <td *ngIf="accountStatment.isAccepted==true && accountStatment.isSentToProsecution==true ">
                                {{ "SentToTheProsecution" | translate}}</td>
                            <td *ngIf="accountStatment.isAccepted==true && accountStatment.isSentToProsecution==false ">
                                {{ "TheRequestHasBeenApproved" | translate}}</td>
                            <td *ngIf="accountStatment.isProsecutionResonse==true">
                                <a href="AccountStatements/requestdatails/{{accountStatment.eAccountStatementId}}"
                                    target="_blank" style="text-decoration: underline;">
                                    {{ "TheProsecutionResponded" | translate }}
                                </a>
                            </td>
                            <td>
                                <a (click)="accountStatmentPreview(accountStatment,previewAccountStatment)"
                                    href="javascript:void(0)">
                                    <i class="fa fa-eye"></i>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>


<!-- add -->
<div class="card p-3" *ngIf="addAccountStatmentShow==true">
    <div style="justify-content: space-between">
        <h4 id="modal-basic-title">
            {{ "AddAccountStatment" | translate }}
        </h4>
    </div>
    <div class="custom-form">
        <div class="col-12 offset-1">
            <div class="card p-3">
                <div class="form-group row">
                    <div class="col-lg-6">
                        <div class="divformlabel">
                            <label>{{ "IdentityTypeForInquery" | translate }}</label>
                            <span *ngIf="IdentityTypes.invalid" class="alert"
                                style="color: red; white-space: nowrap; line-height: 0; padding: 0; margin-top: 8px;">
                                <div *ngIf="IdentityTypes.errors?.required">*</div>
                            </span>
                        </div>
                        <ng-select id="IdentityTypes" required #IdentityTypes="ngModel" class="form-control-select"
                            [items]="identityTypesArr" (change)="selectIdentityType()" bindLabel="text" bindValue="id"
                            [(ngModel)]="identityTypeId" [ngModelOptions]="{ standalone: true }"
                            placeholder="{{ 'IdentityTypeForInquery' | translate }}">
                        </ng-select>
                    </div>
                    <div class="col-lg-6">
                        <div class="divformlabel">
                            <label>
                                {{ "IdentityForInquery" | translate }}
                            </label>
                            <span *ngIf="IdentityNumber.invalid" class="alert" style="
                                color: red;
                                white-space: nowrap;
                                line-height: 0;
                                padding: 0;
                                margin-top: 8px;
                                ">
                                <div *ngIf="IdentityNumber.errors?.required">*</div>
                            </span>
                        </div>
                        <input required #IdentityNumber="ngModel" name="IdentityNumber" id="IdentityNumber"
                            [(ngModel)]="identityForInquery" type="text" class="form-control"
                            placeholder="{{ 'IdentityForInquery' | translate }}" />
                        <span class="alert"
                            style="   color: red;  white-space: nowrap;   line-height: 0;   padding: 0;  margin-top: 8px;   position: absolute;   ">

                            <div *ngIf="!isValidIdentityNumber && !IdentityNumber.errors?.required">
                                {{ "IdentityNumberIsNotValid" | translate }}
                            </div>
                        </span>
                    </div>
                </div>
                <div class="form-group row mt-3">
                    <div class="col-lg-6">
                        <div style="display: flex; flex-wrap: nowrap; height: 30px">
                            <label> {{ "FromDate" | translate }}</label>
                            <span *ngIf="!startDate" class="alert"
                                style="color: red; white-space: nowrap;line-height: 0;padding: 0; margin-top: 8px;">
                                *
                            </span>
                        </div>
                        <datepicker (selectedDateChange)="SelectedFromDateChange($event)" [selectedDateType]="2"
                            [(maxGreg)]="endDateGreg" [(maxHijri)]="endDateHijri"></datepicker>
                    </div>
                    <div class="col-lg-6">
                        <div style="display: flex; flex-wrap: nowrap; height: 30px">
                            <label> {{ "ToDate" | translate }}</label>
                            <span *ngIf="!endDate" class="alert"
                                style="color: red; white-space: nowrap;line-height: 0;padding: 0; margin-top: 8px;">
                                *
                            </span>
                        </div>
                        <datepicker (selectedDateChange)="SelectedEndDateChange($event)" [selectedDateType]="2"
                            [(minGreg)]="startDateGreg" [(minHijri)]="startDateHijri" [(maxHijri)]="currentDateHijri"
                            [(maxGreg)]="currentDate"></datepicker>
                    </div>
                </div>
                <div class="form-group row mt-3">
                    <div class="col-lg-3">
                        <div class="divformlabel">
                            <label>
                                {{ "FirstName" | translate }}
                            </label>
                            <span *ngIf="FirstName.invalid && FirstName.errors?.required" class="alert"
                                style="  color: red; white-space: nowrap;  line-height: 0; padding: 0;  margin-top: 8px; ">
                                *
                            </span>
                        </div>
                        <input required #FirstName="ngModel" name="FirstName" id="FirstName" [(ngModel)]="firstName"
                            type="text" class="form-control" placeholder="{{ 'FirstName' | translate }}" />
                    </div>
                    <div class="col-lg-3">
                        <div class="divformlabel">
                            <label>
                                {{ "SecondName" | translate }}
                            </label>
                            <span *ngIf="SecondName.invalid && SecondName.errors?.required" class="alert"
                                style="  color: red; white-space: nowrap;  line-height: 0; padding: 0;  margin-top: 8px; ">
                                *
                            </span>
                        </div>
                        <input required #SecondName="ngModel" name="SecondName" id="SecondName" [(ngModel)]="secondName"
                            type="text" class="form-control" placeholder="{{ 'SecondName' | translate }}" />
                    </div>
                    <div class="col-lg-3">
                        <div class="divformlabel">
                            <label>
                                {{ "ThirdName" | translate }}
                            </label>
                            <span *ngIf="ThirdName.invalid && ThirdName.errors?.required" class="alert"
                                style="  color: red; white-space: nowrap;  line-height: 0; padding: 0;  margin-top: 8px; ">
                                *
                            </span>
                        </div>
                        <input required #ThirdName="ngModel" name="ThirdName" id="ThirdName" [(ngModel)]="thirdName"
                            type="text" class="form-control" placeholder="{{ 'ThirdName' | translate }}" />
                    </div>
                    <div class="col-lg-3">
                        <div class="divformlabel">
                            <label>
                                {{ "FourthName" | translate }}
                            </label>
                            <span *ngIf="FourthName.invalid && FourthName.errors?.required" class="alert"
                                style="  color: red; white-space: nowrap;  line-height: 0; padding: 0;  margin-top: 8px; ">
                                *
                            </span>
                        </div>
                        <input required #FourthName="ngModel" name="FourthName" id="FourthName" [(ngModel)]="fourthName"
                            type="text" class="form-control" placeholder="{{ 'FourthName' | translate }}" />
                    </div>
                </div>
                <div class="form-group row mt-3">
                    <div class="col-lg-6">
                        <div style="display: flex; flex-wrap: nowrap; height: 30px">
                            <label>{{ "prosecutionName" | translate }}</label>
                            <span *ngIf="ProsecutionName.invalid" class="alert"
                                style="color: red;white-space: nowrap;line-height: 0; padding: 0;margin-top: 8px;">
                                <div *ngIf="ProsecutionName.errors?.required">*</div>
                            </span>
                        </div>
                        <ng-select type="text" id="ProsecutionName" required #ProsecutionName="ngModel"
                            class="form-control-select" [items]="branchProsecutionArr" bindLabel="text" bindValue="id"
                            [(ngModel)]="prosecuationId" [ngModelOptions]="{ standalone: true }"
                            placeholder="{{ 'prosecutionName' | translate }}"></ng-select>
                    </div>
                    <div class="col-lg-6">
                        <div class="divformlabel">
                            <label>{{ "Nationality" | translate }}</label>
                            <span *ngIf="Nationality.invalid" class="alert"
                                style="color: red; white-space: nowrap; line-height: 0; padding: 0; margin-top: 8px;">
                                <div *ngIf="Nationality.errors?.required">*</div>
                            </span>
                        </div>
                        <ng-select id="Nationality" required #Nationality="ngModel" class="form-control-select"
                            [items]="nationalityArr" bindLabel="text" bindValue="id" [(ngModel)]="nationalityId"
                            [ngModelOptions]="{ standalone: true }" placeholder="{{ 'Nationality' | translate }}">
                        </ng-select>
                    </div>
                </div>
                <div class="form-group row mt-3">
                    <div class="col-lg-6">
                        <div style="display: flex; flex-wrap: nowrap; height: 30px">
                            <label>{{ "DraftingRequest" | translate }}</label>
                            <span *ngIf="DraftingRequest.invalid" class="alert"
                                style="color: red;white-space: nowrap;line-height: 0; padding: 0;margin-top: 8px;">
                                <div *ngIf="DraftingRequest.errors?.required">*</div>
                            </span>
                        </div>
                        <textarea id="DraftingRequest" required #DraftingRequest="ngModel" class="form-control" rows="2"
                            [(ngModel)]="draftingRequest" [ngModelOptions]="{ standalone: true }"
                            placeholder="{{ 'DraftingRequest' | translate }}">
                            </textarea>
                    </div>
                    <div class="col-lg-6">
                        <div style="display: flex; flex-wrap: nowrap; height: 30px">
                            <label>{{ "EvidenceAccountStatment" | translate }}</label>
                            <span *ngIf="EvidenceAccountStatment.invalid" class="alert"
                                style="color: red;white-space: nowrap;line-height: 0; padding: 0;margin-top: 8px;">
                                <div *ngIf="EvidenceAccountStatment.errors?.required">*</div>
                            </span>
                        </div>
                        <textarea id="EvidenceAccountStatment" required #EvidenceAccountStatment="ngModel"
                            class="form-control" rows="2" [(ngModel)]="evidences"
                            [ngModelOptions]="{ standalone: true }"
                            placeholder="{{ 'EvidenceAccountStatment' | translate }}">
                            </textarea>
                    </div>
                </div>
                <div class="form-group row mt-3">
                    <div class="col-lg-12">
                        <div style="display: flex; flex-wrap: nowrap; height: 30px">
                            <label>{{ "Categories Request" | translate }}</label>
                            <span *ngIf="catRequest.invalid" class="alert"
                                style="color: red;white-space: nowrap;line-height: 0; padding: 0;margin-top: 8px;">
                                <div *ngIf="catRequest.errors?.required">*</div>
                            </span>
                        </div>
                        <ng-select type="text" id="catRequest" required #catRequest="ngModel"
                            class="form-control-select" [items]="accountStatmentRequestCategoriesArr" bindLabel="text"
                            bindValue="id" [(ngModel)]="accountStatmentRequestCategoriesId"
                            [ngModelOptions]="{ standalone: true }"
                            placeholder="{{ 'Categories Request' | translate }}"></ng-select>
                    </div>
                </div>
                <div class="form-group row mt-3">
                    <div class="col-lg-12">
                        <div style="display: flex; flex-wrap: nowrap; height: 30px">
                            <label>{{ "Events" | translate }}</label>
                            <span *ngIf="Events.invalid && Events.errors?.required" class="alert"
                                style="color: red;white-space: nowrap;line-height: 0; padding: 0;margin-top: 8px;">*
                            </span>
                        </div>
                        <textarea id="Events" required #Events="ngModel" class="form-control" rows="2"
                            [(ngModel)]="events" [ngModelOptions]="{ standalone: true }"
                            placeholder="{{ 'Events' | translate }}"></textarea>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row m-2 col-12 justify-content-center">

        <button
            [disabled]="IdentityTypes.invalid || IdentityNumber.invalid || !isValidIdentityNumber ||!startDate || !endDate || DraftingRequest.invalid || EvidenceAccountStatment.invalid || ProsecutionName.invalid || FirstName.invalid || SecondName.invalid || ThirdName.invalid || FourthName.invalid || Nationality.invalid || Events.invalid || catRequest.invalid "
            (click)="addAccountStatment()" type="button" class="btn btn-primary col-lg-2 m-1">
            {{ "Save" | translate }}
        </button>

        <button
            [disabled]="IdentityTypes.invalid || IdentityNumber.invalid || !isValidIdentityNumber ||!startDate || !endDate || DraftingRequest.invalid || EvidenceAccountStatment.invalid || ProsecutionName.invalid || FirstName.invalid || SecondName.invalid || ThirdName.invalid || FourthName.invalid || Nationality.invalid || Events.invalid || catRequest.invalid"
            (click)="addAccountStatmentAndBack()" type="button" class="btn btn-primary col-lg-2 m-1">
            {{ "Save and Back" | translate }}

        </button>
        <button type="button" class="btn btn-danger col-lg-2 m-1" (click)="addAccountStatmentShow=false;">
            {{ "BackLists" | translate }}
          </button>
    </div>
    <h4 class="mt-3" *ngIf="AttachShow">{{ "Attachments" | translate }}</h4>
    <hr>
    <app-general-attachment *ngIf="AttachShow" [ElementTypeId]="'6'"
        [loadDataFP]="loadfromparent2"></app-general-attachment>


</div>
<ng-template #editAccountStatmentModal let-modal>
    <div class="modal-header" style="justify-content: space-between">
        <h4 class="modal-title" id="modal-basic-title">
            {{ "EditAccountStatment" | translate }}
        </h4>

        <i style="font-size: 20px" class="fa fa-close" (click)="modal.dismiss('Cross click')"></i>
    </div>
    <div class="modal-body">
        <div class="custom-form">
            <div class="col-12 offset-1">
                <div class="card p-3">
                    <div class="form-group row mt-3">
                        <div class="col-lg-6">
                            <div class="divformlabel">
                                <label>{{ "IdentityTypeForInquery" | translate }}</label>
                                <span *ngIf="EditIdentityTypes.invalid" class="alert"
                                    style="color: red; white-space: nowrap; line-height: 0; padding: 0; margin-top: 8px;">
                                    <div *ngIf="EditIdentityTypes.errors?.required">*</div>
                                </span>
                            </div>
                            <ng-select id="IdentityTypes" required #EditIdentityTypes="ngModel"
                                class="form-control-select" [items]="identityTypesArr" (change)="selectIdentityType()"
                                bindLabel="text" bindValue="id" [(ngModel)]="editedAccountStatment.identityTypeId"
                                [ngModelOptions]="{ standalone: true }"
                                placeholder="{{ 'IdentityTypeForInquery' | translate }}">
                            </ng-select>
                        </div>
                        <div class="col-lg-6">
                            <div class="divformlabel">
                                <label>
                                    {{ "IdentityForInquery" | translate }}
                                </label>
                                <span *ngIf="EditIdentityNumber.invalid" class="alert" style="
                            color: red;
                            white-space: nowrap;
                            line-height: 0;
                            padding: 0;
                            margin-top: 8px;
                            ">
                                    <div *ngIf="EditIdentityNumber.errors?.required">*</div>
                                </span>
                            </div>
                            <input (keyup)="numberOnly($event, true)" [readOnly]="inputMethod=='inCompany'" required
                                #EditIdentityNumber="ngModel" name="EditIdentityNumber" id="EditIdentityNumber"
                                [(ngModel)]="editedAccountStatment.identityForInquery" type="text" class="form-control"
                                placeholder="{{ 'IdentityForInquery' | translate }}" />
                            <span class="alert" style="
                            color: red;
                            white-space: nowrap;
                            line-height: 0;
                            padding: 0;
                            margin-top: 8px;
                            position: absolute;
                        ">
                                <!-- <div
                            *ngIf="
                            EditIdentityNumber.errors?.minlength &&
                            isValidIqamaNumber &&
                            isValidIdentityNumber
                            "
                        >
                            {{ "IdentityNumberMustBe10Number" | translate }}
                        </div> -->
                                <!-- <div
                            *ngIf="
                            !isValidIqamaNumber && !EditIdentityNumber.errors?.required
                            "
                        >
                            {{ "IqamaNumberMustStartWith2" | translate }}
                        </div> -->
                                <!-- <div
                            *ngIf="
                            !isValidIdentityNumber && !EditIdentityNumber.errors?.required
                            "
                        >
                            {{ "IdentityNumberMustStartWith1" | translate }}
                        </div> -->
                                <div *ngIf="!isValidIdentityNumber && !EditIdentityNumber.errors?.required">
                                    {{ "IdentityNumberIsNotValid" | translate }}
                                </div>
                            </span>
                        </div>
                    </div>
                    <div class="form-group row mt-3">
                        <div class="col-lg-3">
                            <div class="divformlabel">
                                <label>
                                    {{ "FirstName" | translate }}
                                </label>
                                <span *ngIf="EditFirstName.invalid && EditFirstName.errors?.required" class="alert"
                                    style="  color: red; white-space: nowrap;  line-height: 0; padding: 0;  margin-top: 8px; ">
                                    *
                                </span>
                            </div>
                            <input required #EditFirstName="ngModel" name="EditFirstName" id="EditFirstName"
                                [(ngModel)]="editedAccountStatment.firstName" type="text" class="form-control"
                                placeholder="{{ 'FirstName' | translate }}" />
                        </div>
                        <div class="col-lg-3">
                            <div class="divformlabel">
                                <label>
                                    {{ "SecondName" | translate }}
                                </label>
                                <span *ngIf="EditSecondName.invalid && EditSecondName.errors?.required" class="alert"
                                    style="  color: red; white-space: nowrap;  line-height: 0; padding: 0;  margin-top: 8px; ">
                                    *
                                </span>
                            </div>
                            <input required #EditSecondName="ngModel" name="EditSecondName" id="EditSecondName"
                                [(ngModel)]="editedAccountStatment.secondName" type="text" class="form-control"
                                placeholder="{{ 'SecondName' | translate }}" />
                        </div>
                        <div class="col-lg-3">
                            <div class="divformlabel">
                                <label>
                                    {{ "ThirdName" | translate }}
                                </label>
                                <span *ngIf="EditThirdName.invalid && EditThirdName.errors?.required" class="alert"
                                    style="  color: red; white-space: nowrap;  line-height: 0; padding: 0;  margin-top: 8px; ">
                                    *
                                </span>
                            </div>
                            <input required #EditThirdName="ngModel" name="EditThirdName" id="EditThirdName"
                                [(ngModel)]="editedAccountStatment.thirdName" type="text" class="form-control"
                                placeholder="{{ 'ThirdName' | translate }}" />
                        </div>
                        <div class="col-lg-3">
                            <div class="divformlabel">
                                <label>
                                    {{ "FourthName" | translate }}
                                </label>
                                <span *ngIf="EditFourthName.invalid && EditFourthName.errors?.required" class="alert"
                                    style="  color: red; white-space: nowrap;  line-height: 0; padding: 0;  margin-top: 8px; ">
                                    *
                                </span>
                            </div>
                            <input required #EditFourthName="ngModel" name="EditFourthName" id="EditFourthName"
                                [(ngModel)]="editedAccountStatment.fourName" type="text" class="form-control"
                                placeholder="{{ 'FourthName' | translate }}" />
                        </div>
                    </div>
                    <div class="form-group row mt-3">
                        <div class="col-lg-6">
                            <div style="display: flex; flex-wrap: nowrap; height: 30px">
                                <label> {{ "FromDate" | translate }}</label>
                                <span *ngIf="!editedAccountStatment.startDate" class="alert"
                                    style="color: red; white-space: nowrap;line-height: 0;padding: 0; margin-top: 8px;">
                                    *
                                </span>
                            </div>
                            <datepicker (selectedDateChange)="SelectedFromDateEditChange($event)" [selectedDateType]="2"
                                [(selectedDate)]="editedStartDate" [(maxGreg)]="endDateGreg"
                                [(maxHijri)]="endDateHijri"></datepicker>
                        </div>
                        <div class="col-lg-6">
                            <div style="display: flex; flex-wrap: nowrap; height: 30px">
                                <label> {{ "ToDate" | translate }}</label>
                                <span *ngIf="!editedAccountStatment.endDate" class="alert"
                                    style="color: red; white-space: nowrap;line-height: 0;padding: 0; margin-top: 8px;">
                                    *
                                </span>
                            </div>
                            <datepicker (selectedDateChange)="SelectedEndDateEditChange($event)" [selectedDateType]="2"
                                [(selectedDate)]="editedEndDate" [(minGreg)]="startDateGreg"
                                [(minHijri)]="startDateHijri" [(maxHijri)]="currentDateHijri" [(maxGreg)]="currentDate">
                            </datepicker>
                        </div>
                    </div>
                    <div class="form-group row mt-3">
                        <div class="col-lg-6">
                            <div style="display: flex; flex-wrap: nowrap; height: 30px">
                                <label>{{ "DraftingRequest" | translate }}</label>
                                <span *ngIf="EditDraftingRequest.invalid" class="alert"
                                    style="color: red;white-space: nowrap;line-height: 0; padding: 0;margin-top: 8px;">
                                    <div *ngIf="EditDraftingRequest.errors?.required">*</div>
                                </span>
                            </div>
                            <textarea id="EditDraftingRequest" required #EditDraftingRequest="ngModel"
                                class="form-control" rows="2" [(ngModel)]="editedAccountStatment.draftingRequest"
                                [ngModelOptions]="{ standalone: true }"
                                placeholder="{{ 'DraftingRequest' | translate }}">
                        </textarea>
                        </div>
                        <div class="col-lg-6">
                            <div style="display: flex; flex-wrap: nowrap; height: 30px">
                                <label>{{ "EvidenceAccountStatment" | translate }}</label>
                                <span *ngIf="EditEvidenceAccountStatment.invalid" class="alert"
                                    style="color: red;white-space: nowrap;line-height: 0; padding: 0;margin-top: 8px;">
                                    <div *ngIf="EditEvidenceAccountStatment.errors?.required">*</div>
                                </span>
                            </div>
                            <textarea id="EditEvidenceAccountStatment" required #EditEvidenceAccountStatment="ngModel"
                                class="form-control" rows="2" [(ngModel)]="editedAccountStatment.evidences"
                                [ngModelOptions]="{ standalone: true }"
                                placeholder="{{ 'EvidenceAccountStatment' | translate }}">
                        </textarea>
                        </div>
                    </div>
                    <div class="form-group row mt-3">
                        <div class="col-lg-12">
                            <div style="display: flex; flex-wrap: nowrap; height: 30px">
                                <label>{{ "Categories Request" | translate }}</label>
                                <span *ngIf="EditCatRequest.invalid" class="alert"
                                    style="color: red;white-space: nowrap;line-height: 0; padding: 0;margin-top: 8px;">
                                    <div *ngIf="EditCatRequest.errors?.required">*</div>
                                </span>
                            </div>
                            <ng-select type="text" id="EditCatRequest" required #EditCatRequest="ngModel"
                                class="form-control-select" [items]="accountStatmentRequestCategoriesArr"
                                bindLabel="text" bindValue="id" [(ngModel)]="editedAccountStatment.catRequest"
                                [ngModelOptions]="{ standalone: true }"
                                placeholder="{{ 'Categories Request' | translate }}"></ng-select>
                        </div>
                    </div>
                    <div class="form-group row mt-3">
                        <div class="col-lg-12">
                            <div style="display: flex; flex-wrap: nowrap; height: 30px">
                                <label>{{ "Events" | translate }}</label>
                                <span *ngIf="EditEvents.invalid && EditEvents.errors?.required" class="alert"
                                    style="color: red;white-space: nowrap;line-height: 0; padding: 0;margin-top: 8px;">*
                                </span>
                            </div>
                            <textarea id="EditEvents" required #EditEvents="ngModel" class="form-control" rows="2"
                                [(ngModel)]="editedAccountStatment.events" [ngModelOptions]="{ standalone: true }"
                                placeholder="{{ 'Events' | translate }}"></textarea>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="row m-2 col-12 justify-content-center">
            <button
                [disabled]="EditIdentityTypes.invalid || EditIdentityNumber.invalid  || !isValidIdentityNumber || !editedAccountStatment.startDate || !editedAccountStatment.endDate || EditDraftingRequest.invalid || EditEvidenceAccountStatment.invalid || EditFirstName.invalid || EditSecondName.invalid|| EditThirdName.invalid|| EditFourthName.invalid  || EditEvents.invalid || EditCatRequest.invalid"
                (click)="onEditAccountStatment(modal)" type="button" class="btn btn-primary col-lg-2">
                {{ "Save" | translate }}
            </button>
        </div>
        <h4 class="mt-3">{{ "Attachments" | translate }}</h4>
        <hr>
        <app-general-attachment [ElementTypeId]="'6'" [loadDataFP]="loadfromparent3"></app-general-attachment>


    </div>
    <div class="modal-footer">

        <button type="button" class="btn btn-danger col-lg-3" (click)="modal.dismiss('Cross click')">
            {{ "Close" | translate }}
        </button>
    </div>

</ng-template>
<ng-template #deleteModal let-modal>
    <div class="modal-header" style="justify-content: space-between">
        <h4 class="modal-title" id="modal-basic-title">
            {{ "ConfirmDeleteOperation" | translate }}
        </h4>
        <i style="font-size: 20px" class="fa fa-close" (click)="modal.dismiss('Cross click')"></i>
    </div>
    <div class="modal-body text-center">
        <p>{{ "SelectedRecordwillbeDeleted" | translate }}</p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-danger" (click)="onDeleteAccountStatment(modal)">
            {{ "YES" | translate }}
        </button>
        <button type="button" class="btn btn-primary" (click)="modal.dismiss('Cross click')">
            {{ "NO" | translate }}
        </button>
    </div>
</ng-template>

<ng-template #AddAttachment let-modal>
    <div class="modal-header" style="justify-content: space-between">
        <h4 class="modal-title" id="modal-basic-title">
            {{'Attachments'|translate}}
        </h4>
        <i style="font-size: 20px" class="fa fa-close" (click)="modal.dismiss('Cross click')"></i>

    </div>
    <div class="modal-body text-center">
        <app-general-attachment [ElementTypeId]="'6'" [loadDataFP]="loadfromparent"></app-general-attachment>

    </div>
    <div class="modal-footer">

        <button type="button" class="btn btn-primary" (click)="modal.dismiss('Cross click')">
            {{ "Close" | translate }}
        </button>
    </div>
</ng-template>
<ng-template #previewAccountStatment let-modal>
    <div class="modal-header" style="justify-content: space-between">
        <h4 class="modal-title" id="modal-basic-title">
            {{ "PreviewAccountStatment" | translate }}
        </h4>

        <i style="font-size: 20px" class="fa fa-close" (click)="modal.dismiss('Cross click')"></i>
    </div>
    <div class="modal-body">
        <div class="custom-form">
            <div class="col-12 offset-1">
                <div class="card p-3">
                    <div class="form-group row">
                        <div class="col-lg-6">
                            <label>{{ "IdentityTypeForInquery" | translate }}</label>
                            <span class="form-control" readonly>{{editedAccountStatment.identityTypeName}}&nbsp;</span>
                        </div>
                        <div class="col-lg-6">
                            <label> {{ "IdentityForInquery" | translate }}</label>
                            <span class="form-control"
                                readonly>{{editedAccountStatment.identityForInquery}}&nbsp;</span>
                        </div>
                    </div>
                    <div class="form-group row mt-1">
                        <div class="col-lg-3">
                            <label>{{ "FirstName" | translate }}</label>
                            <span class="form-control" readonly>{{ editedAccountStatment.firstName}}&nbsp;</span>
                        </div>
                        <div class="col-lg-3">
                            <label>{{ "SecondName" | translate }}</label>
                            <span class="form-control" readonly>{{ editedAccountStatment.secondName}}&nbsp;</span>
                        </div>
                        <div class="col-lg-3">
                            <label>{{ "ThirdName" | translate }}</label>
                            <span class="form-control" readonly>{{ editedAccountStatment.thirdName}}&nbsp;</span>
                        </div>
                        <div class="col-lg-3">
                            <label>{{ "FourthName" | translate }}</label>
                            <span class="form-control" readonly>{{ editedAccountStatment.fourName}}&nbsp;</span>
                        </div>
                    </div>
                    <div class="form-group row mt-1">
                        <div class="col-lg-6">
                            <label> {{ "FromDate" | translate }}</label>
                            <span class="form-control" readonly>{{editedAccountStatment.startDate |
                                toDateOnly}}&nbsp;</span>
                        </div>
                        <div class="col-lg-6">
                            <label> {{ "ToDate" | translate }}</label>
                            <span class="form-control" readonly>{{editedAccountStatment.endDate |
                                toDateOnly}}&nbsp;</span>
                        </div>
                    </div>

                    <div class="form-group row mt-1">
                        <div class="col-lg-6">
                            <label>{{ "prosecutionName" | translate }}</label>
                            <span class="form-control" readonly>{{ editedAccountStatment.prosecutionName}}&nbsp;</span>
                        </div>
                        <div class="col-lg-6">
                            <label>{{ "Nationality" | translate }}</label>
                            <span class="form-control" readonly>{{ editedAccountStatment.nationalityName}}&nbsp;</span>
                        </div>
                    </div>
                    <div class="form-group row mt-1">
                        <div class="col-lg-12 mt-1">
                            <label>{{ "DraftingRequest" | translate }}</label>
                            <span class="form-control" readonly>{{editedAccountStatment.draftingRequest}}&nbsp;</span>
                        </div>
                        <div class="col-lg-12 mt-1">
                            <label>{{ "EvidenceAccountStatment" | translate }}</label>
                            <span class="form-control" readonly>{{editedAccountStatment.evidences}}&nbsp;</span>
                        </div>
                        <div class="col-lg-12 mt-1">
                            <label>{{ "Categories Request" | translate }}</label>
                            <span class="form-control"
                                readonly>{{editedAccountStatment.accountStatmentRequestCategoryName ?
                                editedAccountStatment.accountStatmentRequestCategoryName : '-'}}&nbsp;</span>
                        </div>
                        <div class="col-lg-12 mt-1">
                            <label>{{ "Events" | translate }}</label>
                            <span class="form-control" readonly>{{editedAccountStatment.events ?
                                editedAccountStatment.events : '-'}}&nbsp;</span>
                        </div>
                    </div>
                    <hr>
                    <h3>{{'Attachments' | translate}}</h3>
                    <app-general-attachment [ElementTypeId]="'6'"
                        [loadDataFP]="loadfromparent4"></app-general-attachment>

                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer row" style="justify-content: flex-end; padding: 1rem 2rem">


        <button
            *ngIf="(Process.Company && sharedService.hasRole(RoleEnum.Manager)) || (Process.Consumer && sharedService.hasRole(RoleEnum.Quality))"
            (click)="open(RefusedRequestModal)" type="button" class="btn btn-primary col-lg-2">
            {{ "Refused" | translate }}
        </button>

        <button
            *ngIf="(Process.Company && sharedService.hasRole(RoleEnum.Manager)) || (Process.Consumer && sharedService.hasRole(RoleEnum.Quality))"
            (click)="isAcceptFun(true)" type="button" class="btn btn-primary col-lg-3">
            {{ "SentToProsecution" | translate }}
        </button>
        <button type="button" class="btn btn-danger col-lg-2" (click)="modal.dismiss('Cross click')">
            {{ "Close" | translate }}
        </button>
        <!-- <button  type="button" class="btn btn-primary col-lg-2" >
      {{ "Refused" | translate }}
    </button>

    <button type="button" class="btn btn-primary col-lg-3" >
      {{ "ReferralToTheProsecution" | translate }}
    </button> -->
    </div>

</ng-template>
<ng-template #RefusedRequestModal let-modal>
    <div class="modal-header" style="justify-content: center">
        <h4 class="modal-title" id="modal-basic-title">
            {{ "Confirm" | translate }}
        </h4>
    </div>
    <div class="modal-body text-center">
        <div class="row">
            <div class="col-lg-12">
                <div style="display: flex; flex-wrap: nowrap; height: 30px">
                    <label>{{ "TheReason" | translate }}</label>
                    <span *ngIf="TheReason.invalid" class="alert"
                        style="color: red; white-space: nowrap; line-height: 0; padding: 0; margin-top: 8px;">
                        <div *ngIf="TheReason.errors?.required">*</div>
                    </span>
                </div>
                <textarea id="TheReason" required #TheReason="ngModel" class="form-control" rows="2"
                    [(ngModel)]="editedAccountStatment.rejectReason" [ngModelOptions]="{ standalone: true }"
                    placeholder="{{ 'TheReason' | translate }}">
          </textarea>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary" [disabled]="TheReason.invalid" (click)="isAcceptFun(false)">
            {{ "Confirm" | translate }}
        </button>
    </div>
</ng-template>